// ─────────────────────────────────────────────────────────────────────────
// Prim Yönetimi modülü için GraphQL queryleri.
// Naming convention: useDynamicEntity hook'u graphql/index'ten string ile
// import ettiği için "*_QUERY" / "*_MUTATION" suffix'leri gerekli.
// ─────────────────────────────────────────────────────────────────────────

export const GET_BONUS_REVENUE_TYPES_QUERY = `
  query GetBonusRevenueTypes(
    $where: bonus_revenue_types_bool_exp = {}
    $limit: Int
    $offset: Int
  ) {
    bonus_revenue_types_aggregate(where: $where) {
      aggregate { count }
    }
    bonus_revenue_types(where: $where, order_by: { code: asc }, limit: $limit, offset: $offset) {
      id
      company_id
      name
      code
      coefficient
      applicable_channels
      created_at
      updated_at
      company { id name }
    }
  }
`;

export const GET_BONUS_REVENUE_RULES_QUERY = `
  query GetBonusRevenueRules(
    $where: bonus_revenue_rules_bool_exp = {}
    $limit: Int
    $offset: Int
  ) {
    bonus_revenue_rules_aggregate(where: $where) {
      aggregate { count }
    }
    bonus_revenue_rules(where: $where, order_by: { created_at: desc }, limit: $limit, offset: $offset) {
      id
      company_id
      ciro_kanali
      aciklama
      operation
      created_at
      rule_teams {
        team_id
        team { id name }
      }
      company { id name }
    }
  }
`;

export const GET_BONUS_RULES_QUERY = `
  query GetBonusRules(
    $where: bonus_rules_bool_exp = {}
    $limit: Int
    $offset: Int
  ) {
    bonus_rules_aggregate(where: $where) {
      aggregate { count }
    }
    bonus_rules(
      where: $where
      order_by: [{ baslangic_yil: desc }, { baslangic_ceyrek: desc }]
      limit: $limit
      offset: $offset
    ) {
      id
      company_id
      aciklama
      sabit_yuzdelik_aktif
      sabit_yuzdelik_deger
      prim_hakedis_esik_orani
      baz_prim_orani
      baslangic_yil
      baslangic_ceyrek
      bitis_yil
      bitis_ceyrek
      is_active
      created_at
      rule_teams {
        team_id
        team { id name }
      }
      company { id name }
    }
  }
`;

export const GET_USER_BONUS_COEFFICIENTS_QUERY = `
  query GetUserBonusCoefficients(
    $where: user_bonus_coefficients_bool_exp = {}
    $limit: Int
    $offset: Int
  ) {
    user_bonus_coefficients_aggregate(where: $where) {
      aggregate { count }
    }
    user_bonus_coefficients(
      where: $where
      order_by: [{ yil: desc }, { ceyrek: desc }]
      limit: $limit
      offset: $offset
    ) {
      id
      company_id
      user_id
      yil
      ceyrek
      katsayi
      created_at
      updated_at
      user { id first_name last_name }
      company { id name }
    }
  }
`;

// Bulk modal için belirli bir (yıl, çeyrek, company) periyodundaki mevcut
// katsayıları okur. Inputlara default değer yerleştirmek için kullanılır.
export const GET_USER_BONUS_COEFFICIENTS_BY_PERIOD_QUERY = `
  query GetUserBonusCoefficientsByPeriod(
    $where: user_bonus_coefficients_bool_exp = {}
  ) {
    user_bonus_coefficients(where: $where) {
      id
      user_id
      yil
      ceyrek
      katsayi
    }
  }
`;

export const GET_BONUS_TARGETS_QUERY = `
  query GetBonusTargets(
    $where: bonus_targets_bool_exp = {}
    $limit: Int
    $offset: Int
  ) {
    bonus_targets(
      where: $where
      order_by: [{ yil: desc }, { ceyrek: desc }]
      limit: $limit
      offset: $offset
    ) {
      id
      company_id
      yil
      ceyrek
      team_id
      user_id
      hedef_tutar
      aciklama
      created_at
      team { id name }
      user { id first_name last_name }
      company { id name }
    }
  }
`;

export const GET_BONUS_PAYMENTS_QUERY = `
  query GetBonusPayments(
    $where: bonus_payments_bool_exp = {}
    $limit: Int
    $offset: Int
  ) {
    bonus_payments_aggregate(where: $where) {
      aggregate { count }
    }
    bonus_payments(
      where: $where
      order_by: [{ tarih: desc }]
      limit: $limit
      offset: $offset
    ) {
      id
      company_id
      user_id
      islem_turu
      tarih
      yil
      ceyrek
      tutar
      aciklama
      created_at
      user { id first_name last_name }
      company { id name }
    }
  }
`;

